import { isValid } from 'date-fns';
import { formatLocalDate } from '@/common/utils/dateFormats';

export const DEFAULT_DATE_FORMAT = 'dd MMM, yyyy';

export const defaultFormatDate = (date?: string): string => {
  if (!date) return '';
  const isParseableDate = isValid(new Date(date));
  if (!isParseableDate) return date;
  return formatLocalDate(date, DEFAULT_DATE_FORMAT);
};
